import type { KinerjaStatusGpk } from 'types/kinerja-gpk'

export function isValidPerencanaanStatus(
  status: unknown
): status is KinerjaStatusGpk {
  return (
    typeof status === 'string' &&
    [
      'NOT_FOUND',
      'DRAFT',
      'WAITING_APPROVAL',
      'REVISION_TK',
      'REVISION_PPK',
      'WAITING_APPROVAL_PPK',
      'APPROVED',
      'READY',
    ].includes(status)
  )
}
